/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aria_Delete_NotificationInputs */

const en_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete notification`)
};

const de_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung loeschen`)
};

const fr_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la notification`)
};

const es_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar notificacion`)
};

const it_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina notifica`)
};

const nl_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melding verwijderen`)
};

const pl_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usun powiadomienie`)
};

const fi_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista ilmoitus`)
};

const da_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet notifikation`)
};

const sv_aria_delete_notification = /** @type {(inputs: Aria_Delete_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort meddelande`)
};

/**
* | output |
* | --- |
* | "Delete notification" |
*
* @param {Aria_Delete_NotificationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const aria_delete_notification = /** @type {((inputs?: Aria_Delete_NotificationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aria_Delete_NotificationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_aria_delete_notification(inputs)
	if (locale === "fr") return fr_aria_delete_notification(inputs)
	if (locale === "es") return es_aria_delete_notification(inputs)
	if (locale === "it") return it_aria_delete_notification(inputs)
	if (locale === "nl") return nl_aria_delete_notification(inputs)
	if (locale === "pl") return pl_aria_delete_notification(inputs)
	if (locale === "fi") return fi_aria_delete_notification(inputs)
	if (locale === "da") return da_aria_delete_notification(inputs)
	if (locale === "sv") return sv_aria_delete_notification(inputs)
	return en_aria_delete_notification(inputs)
});